export default __webpack_public_path__ + "static/media/gemibasi7.92cd1f70.jpg";